<div *ngIf="value" class="activity-wrapper">
  <div class="icon-wrapper">
    <jf-icon name="beleg" iconColor="black"></jf-icon>
  </div>

  <div class="activity-data">
    <div class="title">
      {{ value.title }}
    </div>
    <div class="description">
      {{ value.description ? value.description : '' }}
    </div>
  </div>

  <div class="progress-indicator">
    <mat-progress-spinner
      *ngIf="!value.done"
      [diameter]="20"
      [mode]="value.mode"
      [value]="value.progress"
      [color]="'accent'"
    ></mat-progress-spinner>

    <jf-icon *ngIf="value.success" name="done" iconColor="black"></jf-icon>

    <jf-icon *ngIf="value.failed" name="warning" iconColor="#FF4747"></jf-icon>
  </div>
</div>
